import { Component as ErrorComponent } from 'components/common-form/sidePanel/status/error/Error.status';
import { QuotedPreviouslyStatus } from 'components/common-form/sidePanel/status/quoted.previously/Quoted.Previously.status';
import { Component as QuotedTradableComponent } from 'components/common-form/sidePanel/status/quoted.tradable/Quoted.Tradable.status';
import { Component as QuoteRejectedComponent } from 'components/common-form/sidePanel/status/quoteRejected/QuoteRejected';
import { Component as QuotingComponent } from 'components/common-form/sidePanel/status/quoting/Quoting.status';
import { ValidationErrorComponent } from 'components/common-form/sidePanel/status/validationErrors/ValidationErrors.status';
import { connectQuotedPreviously } from 'components/PostTrade/Addon/components/SidePanel/status/QuotedPreviously.connect';
import type { QuoteKeys, QuoteKeysPrefix } from 'locales/quoteKeys';
import type { FormRecord } from 'models/formError';

import { connectError } from './ErrorComponent.connect';
import { connectQuotedTradable } from './Quoted.Tradable.connect';
import { connectQuoteRejected } from './QuoteRejected.connect';
import { connectQuoting } from './QuotingComponent.connect';
import { TradeDoneComponent } from './trade.done';
import { connectTradeDone } from './trade.done.connect';
import { TradePendingComponent } from './trade.pending';
import { connectTradePending } from './trade.pending.connect';
import { connectValidationErrors } from './ValidationErrors.connect';

export const InError = connectError(ErrorComponent);
export const QuotedTradable = connectQuotedTradable(QuotedTradableComponent);
export const QuoteRejected = connectQuoteRejected(QuoteRejectedComponent);
export const Quoting = connectQuoting(QuotingComponent);
export const QuotedPreviously = connectQuotedPreviously(QuotedPreviouslyStatus);
export const TradePending = connectTradePending(TradePendingComponent);
export const TradeDone = connectTradeDone(TradeDoneComponent);
export const ValidationErrors = connectValidationErrors(
  ValidationErrorComponent<FormRecord, QuoteKeys, QuoteKeysPrefix>,
);
